<template>
  <a-popconfirm
    ref="popRef"
    placement="left"
    :open="open"
    :ok-text="okText"
    :overlayInnerStyle="{ width: 250 }"
    :destroy-tooltip-on-hide="true"
    :cancel-text="cancelText"
    :getPopupContainer="getPopupContainer"
    @cancel="closePopup"
    @confirm="handleConfirm"
  >
    <template #title>
      <div style="width: 250px">
        <slot name="title" />
      </div>
    </template>
    <a-tooltip
      placement="top"
      :title="toolTipTitle"
      :get-popup-container="getPopupContainer"
    >
      <a-button
        ref="root"
        v-bind="$attrs"
        @click="() => (open ? closePopup() : openPopup())"
      >
        <slot></slot>
      </a-button>
    </a-tooltip>
  </a-popconfirm>
</template>

<script lang="ts" setup>
import { getPopupCard, getPopupContainer } from './utils'

defineProps<{
  okText?: string
  cancelText?: string
  toolTipTitle?: string
}>()

const emits = defineEmits(['confirm'])

const open = ref(false)
const root = ref()
const popRef = ref()

const closePopup = () => {
  open.value = false
}

const openPopup = () => {
  open.value = true
  // hack 暂时没有办法拿到popup的dom，也没有渠道监听 popup dom 的出现
  setTimeout(() => {
    popRef.value?.getPopupDomNode()?.addEventListener('mouseleave', closePopup)
  }, 250)
}

onMounted(() => {
  getPopupCard(root.value.$el)?.addEventListener('mouseleave', closePopup)
})

onBeforeUnmount(() => {
  getPopupCard(root.value.$el)?.removeEventListener('mouseleave', closePopup)
})

const handleConfirm = () => {
  open.value = false
  emits('confirm')
}
</script>
